import { Tab, Tabs } from '@collaborate-health/uikit'

import { styled, tabsClasses } from '@mui/material'

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 25,
  overflowX: 'auto',
  position: 'relative',
  margin: 0,

  [`& .${tabsClasses.scroller}`]: {
    overflowX: 'auto !important',
  },

  [`& .${tabsClasses.flexContainer}`]: {
    gap: theme.spacing(0.5),
  },
}))

export const StyledTab = styled(Tab)(({ theme }) => ({
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 60,
  minHeight: 25,
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius / 2,

  // @ts-ignore
  ...theme.typography['uikit-subheader3'],
}))

